import { fExecuteAPI } from "../../Server/Apis";
import {
  GRNNormal_Attributes_GETROW,
  WMSIInbound_WMINV03RSPMSPDetail_API,
  WmsInbound_getPendingPo_API,
  WmsInbound_getPallet_API,
  GRNNormal_INV03_LoadDetail_GETROW,
  GRNNormal_fINV03_fDisplay_GETROW,
  GRNNormal_Inv03CgetRow_GETROW,
  GRNNormal_deleteInv03CRow_GETROW,
  GRNNormal_updateInv03CRow_GETROW,
  GRNNormal_INV03D_GetRow_GETROW,
  fUnitPriceOnChangeGRN,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcovertToNumber,
  fCalculate_Detail,
} from "../../Utility/Utilitys";

import {
  Set_GRNNormal_HeadObject_DrCrAccount,
  Set_GRNNormal_HeadObject_Set,
  Set_GRNNormal_HeadObject_A_PayMode,
  Set_GRNNormal_HeadObject_DiscFlag,
  Wms_HeadObject_SalesGroup_A_Buyer_Set,
} from "./SliceGRNNormal";

import {
  vRdxUserInfo,
  KernCAConfig,
  vRdxtax,
  GRNNormalRo,
} from "../../Redux/roStore";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";

export const BatchDetail_ErrorMsg_Init = {
  BatchDetail_SrNo: "",
  BatchDetail_BatchNo: "",
  BatchDetail_MFDate: "",
  BatchDetail_ExpDate: "",
  BatchDetail_Qty: "",
  BatchDetail_Unit: "",
  BatchDetail_PackQty: "",
  BatchDetail_BaseQty: "",
};
export const ErrorMsg = {
  A_VocTyp: "",
  A_VocNo: "",
  A_PostDt: "",
  A_RefDocVer: "",
  A_RefDocNo: "",
  A_RefDocTyp: "",
  A_RefDocTypName: "",
  A_RefNo: "",
  A_RefDt: "",
  Type: "",
  A_PayMode: "",
  UnloadingBay: "",
  A_Party: "",
  A_PartyName: "",
  VendorInvAmount: "",
  A_Curr: "",
  A_ExRate: "",
  A_Loc: "",
  TaxType: "",
  PurchaseReturnType: "",
  offer: "",
  A_CrAc: "",
  A_CrAcName: "",
  A_DrAc: "",
  A_DrAcName: "",
  A_Type: "",
  A_Rounding: "",
  A_DiscFlag: "",
  A_LC: "",
  A_Charges1: "",
  A_DocStat: "",
  A_AutoBatch: "",
  xErrorMsg: "",
  virtualBin: "",
  A_Buyer: "",
  Rebate: "",
  RCM: "",
  Weighing: "",
  Tax: "",
  TaxGross: "",
  A_Narr: "",
};
export const ErrorMsgDetail = {
  B_Srno: "",
  B_Itmcd: "",
  B_Barcode: "",
  B_ItmName: "",
  B_Qty: "",
  B_Unit: "",
  B_PackQty: "",
  SplDisc: "",
  B_URateFc: "",
  B_URateLc: "",
  B_GrossAmt: "",
  B_TDiscPerc: "",
  B_TDiscAmt: "",
  B_LDiscPerc: "",
  B_LDiscAmt: "",
  B_FocFlag: "",
  B_AprmtFlag: "",
  B_FocAmt: "",
  B_ExciseTaxAmt: "",
  B_ExciseTaxNetAmt: "",
  SplDiscAmt: "",
  B_Base_Rate: "",
  B_TaxDept: "",
  B_TaxPerc: "",
  B_TaxAmt: "",
  B_TaxDept2: "",
  B_TaxPerc2: "",
  B_TaxAmt2: "",
  B_NetAddCess: "",
  RebateType: "",
  ReduceCost: "",
  ExpDate: "",
  HC: "",
  PR: "",
  SplDiscPerc: "",
  B_NetAmt: "",
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "INV03";

const sFocFlagArr = [
  "",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AV",
  "AW",
  "AX",
  "AY",
  "AZ",
  "BA",
  "BB",
  "BC",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BJ",
  "BK",
  "BL",
  "BM",
  "BN",
  "BO",
  "BP",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BU",
  "BV",
  "BW",
  "BX",
  "BY",
  "BZ",
  "CA",
  "CB",
  "CC",
  "CD",
  "CE",
  "CF",
  "CG",
  "CH",
  "CJ",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CP",
  "CQ",
  "CR",
  "CS",
  "CT",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DA",
  "DB",
  "DC",
  "DD",
  "DE",
  "DF",
  "DG",
  "DH",
  "DJ",
  "DK",
  "DL",
  "DM",
  "DN",
  "DO",
  "DP",
  "DQ",
  "DR",
  "DS",
  "DT",
  "DU",
  "DV",
  "DW",
  "DX",
  "DY",
  "DZ",
];
export const sLoadedCostAccountArr = ["Vendor", "G.L A/c"];
export const sLoadedCostToggleData = ["Any", "Code", "Name"];

export const Loaded_Cost_Freight_Init = {
  Loaded_Cost_Freight_Acc: "",
  Loaded_Cost_Freight_Code: "",
  Loaded_Cost_Freight_Name: "",
  Loaded_Cost_Customs_Acc: "",
  Loaded_Cost_Customs_Code: "",
  Loaded_Cost_Customs_Name: "",
  Loaded_Cost_Discount_Code: "",
  Loaded_Cost_Discount_Name: "",
  Loaded_Cost_SplDiscount_Code: "",
  Loaded_Cost_SplDiscount_Name: "",
};
export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];

const sPaymode = [
  { Uid: "CASH", Name: "Cash" },
  { Uid: "CREDIT", Name: "Credit" },
];

const sTax = [
  { Uid: "INTRN001", Name: "VAT" },
  { Uid: "INTRN002", Name: "Inter.Comp" },
  { Uid: "INTRN003", Name: "Import" },
];

const TypeArr = [
  { Uid: "", Name: "" },
  { Uid: "Linewise Rebate", Name: "Linewise Rebate" },
  { Uid: "Credit Note", Name: "Credit Note" },
];
export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

export const xGC_Toggle_Head_Customer_DropDown_Arr = ["Any", "Code", "Name"];
//GCcustomer end
const fKey = (event) => {
  // GRNNormalContent
  const form = document.getElementById("Head");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};
export const UnitRateFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj?.WMINV03_UNITRATE_VLDT?.Val === "N";
  if (iShowField) {
    return false;
  } else {
    return true;
  }
};

export const GetPengingPo = async (
  xVocNo,
  xVocTyp,
  setGridDataAccountDetailRows
) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const iAccountPostingDetail = await WmsInbound_getPendingPo_API(vObj);
  if (iAccountPostingDetail?.status === 200) {
    setGridDataAccountDetailRows(iAccountPostingDetail?.data?.ResultSet);
    console.log(iAccountPostingDetail?.data?.ResultSet);
    return iAccountPostingDetail?.data?.ResultSet;
  }
};
export const GetPallet = async (xVocNo, xVocTyp, setPalletData) => {
  var vObj = {
    v_PO_VocTyp: xVocTyp,
    v_PO_VocNo: xVocNo,
  };
  const resp = await WmsInbound_getPallet_API(vObj);
  if (resp?.status === 200) {
    setPalletData(resp?.data?.ResultSet);
    console.log(resp?.data?.ResultSet);
    return resp?.data?.ResultSet;
  } else {
    setPalletData([]);
  }
};
const fValidationHead_Client = (
  vRdxHead,
  setErrorMsg,
  sFooterObj,
  vMediaQuery,
  fSummary
) => {
  let iRes = true;
  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    fAlertToast("INFO", "VocTyp should not be empty");

    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    fAlertToast("INFO", "VocNo should not be empty");
    iRes = false;
  }

  // default format so no need to check format
  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "PostDt should not be empty",
    }));
    fAlertToast("INFO", "PostDt should not be empty");
    iRes = false;
  }
  if (sFooterObj.A_LandVal < 0) {
    setErrorMsg((obj) => ({
      ...obj,
      A_Rounding: "Transaction amount should be greate then zero",
    }));
    fAlertToast("INFO", "Transaction amount should be greate then zero");
    iRes = false;
  }

  if (
    vRdxHead.A_RefNo === "" ||
    vRdxHead.A_RefNo === null ||
    vRdxHead.A_RefNo === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "InvNo shounld not be empty" }));
    fAlertToast("INFO", "InvNo shounld not be empty");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "POS") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "Text shounld not be POS" }));

    fAlertToast("INFO", "Text shounld not be POS");
    iRes = false;
  } else if (vRdxHead.A_RefNo.toUpperCase() === "CREDIT") {
    setErrorMsg((obj) => ({ ...obj, A_RefNo: "InvNo  shounld not be CREDIT" }));
    fAlertToast("INFO", "InvNo  shounld not be CREDIT");
    iRes = false;
  }

  if (
    vRdxHead.A_RefDt === "" ||
    vRdxHead.A_RefDt === null ||
    vRdxHead.A_RefDt === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_RefDt: "Reference Date should not be Empty",
    }));
    fAlertToast("INFO", "Reference Date should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.A_Party === "" ||
    vRdxHead.A_Party === null ||
    vRdxHead.A_Party === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party should not be empty",
    }));
    fAlertToast("INFO", "Party should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_PartyName === "" ||
    vRdxHead.A_PartyName === null ||
    vRdxHead.A_PartyName === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PartyName: "Party Name should not be empty",
    }));
    fAlertToast("INFO", "Party Name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.VendorInvAmount === "" ||
    vRdxHead.VendorInvAmount === null ||
    vRdxHead.VendorInvAmount === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      VendorInvAmount: "Vendor Inv.Amt should not be empty",
    }));
    fAlertToast("INFO", "Vendor Inv.Amt should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.Type === "" ||
    vRdxHead.Type === null ||
    vRdxHead.Type === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Type: " Type should not be empty",
    }));
    fAlertToast("INFO", "Type should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Curr === "" ||
    vRdxHead.A_Curr === null ||
    vRdxHead.A_Curr === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({ ...obj, A_Curr: "Curr should not be empty" }));
    fAlertToast("INFO", "Curr should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_ExRate === "" ||
    Number(vRdxHead.A_ExRate) === 0 ||
    vRdxHead.A_ExRate === null ||
    vRdxHead.A_ExRate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_ExRate: "ExRate should not be empty",
    }));
    fAlertToast("INFO", "ExRate should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.A_PayMode === "" ||
    vRdxHead.A_PayMode === null ||
    vRdxHead.A_PayMode === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      A_PayMode: "PayMode should not be Empty",
    }));
    fAlertToast("INFO", "PayMode should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be Empty" }));
    fAlertToast("INFO", "Location should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.TaxType === "" ||
    vRdxHead.TaxType === null ||
    vRdxHead.TaxType === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxType: "Tax Type should not be Empty",
    }));
    fAlertToast("INFO", "Tax Type should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Buyer === "" ||
    vRdxHead.A_Buyer === null ||
    vRdxHead.A_Buyer === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_Buyer: "Buyer should not be Empty",
    }));
    fAlertToast("INFO", "Buyer should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.offer === "" ||
    vRdxHead.offer === null ||
    vRdxHead.offer === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      offer: "Offer should not be Empty",
    }));

    fAlertToast("INFO", "Offer should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.Rebate === "" ||
    vRdxHead.Rebate === null ||
    vRdxHead.Rebate === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Rebate: "Rebate should not be Empty",
    }));
    fAlertToast("INFO", "Rebate should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.RCM === "" ||
    vRdxHead.RCM === null ||
    vRdxHead.RCM === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      RCM: "RCM should not be Empty",
    }));
    fAlertToast("INFO", "RCM should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.Weighing === "" ||
    vRdxHead.Weighing === null ||
    vRdxHead.Weighing === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Weighing: "Weighing should not be Empty",
    }));
    fAlertToast("INFO", "Weighing should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.Tax === "" ||
    vRdxHead.Tax === null ||
    vRdxHead.Tax === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Tax: "Tax should not be Empty",
    }));
    fAlertToast("INFO", "Tax should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.TaxGross === "" ||
    vRdxHead.TaxGross === null ||
    vRdxHead.TaxGross === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxGross: "TaxGross should not be Empty",
    }));
    fAlertToast("INFO", "TaxGross should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.RCM === "" ||
    vRdxHead.RCM === null ||
    vRdxHead.RCM === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, RCM: "RCM should not be Empty" }));
    fAlertToast("INFO", "RCM should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.Weighing === "" ||
    vRdxHead.Weighing === null ||
    vRdxHead.Weighing === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      Weighing: "Weighing should not be Empty",
    }));
    fAlertToast("INFO", "Weighing should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.Tax === "" ||
    vRdxHead.Tax === null ||
    vRdxHead.Tax === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Tax: "Tax should not be Empty" }));
    fAlertToast("INFO", "Tax should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.TaxGross === "" ||
    vRdxHead.TaxGross === null ||
    vRdxHead.TaxGross === undefined
  ) {
    setErrorMsg((obj) => ({
      ...obj,
      TaxGross: "TaxGross should not be Empty",
    }));
    fAlertToast("INFO", "TaxGross should not be Empty");
    iRes = false;
  }

  if (
    vRdxHead.Rebate === "" ||
    vRdxHead.Rebate === null ||
    vRdxHead.Rebate === undefined
  ) {
    setErrorMsg((obj) => ({ ...obj, Rebate: "Rebate should not be Empty" }));
    fAlertToast("INFO", "Rebate should not be Empty");
    iRes = false;
  }
  if (
    vRdxHead.A_DiscFlag === "" ||
    vRdxHead.A_DiscFlag === null ||
    vRdxHead.A_DiscFlag === undefined
  ) {
    if (vMediaQuery) {
      fSummary();
    }
    setErrorMsg((obj) => ({
      ...obj,
      A_DiscFlag: "DiscFlag should not be Empty",
    }));
    fAlertToast("INFO", "DiscFlag should not be Empty");
    iRes = false;
  }
  return iRes;
};

const fValidationDetail_Client = (
  vRdxHead,
  sBufferObj,
  setErrorMsgDetail,
  sDetailGridData
) => {
  let iRes = true;

  if (sBufferObj.B_Srno === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));

    fAlertToast("INFO", "Serial number should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Itmcd === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    fAlertToast("INFO", "Item code should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_ItmName === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    fAlertToast("INFO", "Item name should not be empty");
    iRes = false;
  }

  if (sBufferObj.B_Qty === "") {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Quantity   should not be zero",
    }));
    fAlertToast("INFO", "Quantity   should not be zero");
    iRes = false;
  }
  if (Number(sBufferObj.B_Qty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Qty: "Negative  quantity not allowed",
    }));
    fAlertToast("INFO", "Negative  quantity not allowed");
    iRes = false;
  }

  if (sBufferObj.B_Unit === "") {
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    fAlertToast("INFO", "Select unit");
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    fAlertToast("INFO", "Pack quantity should not be zero");
    iRes = false;
  }
  if (UnitRateFlag()) {
    if (Number(sBufferObj.B_URateFc) <= 0 || sBufferObj.B_URateFc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_URateFc: "Unit rate[F.C] should not be Zero",
      }));
      fAlertToast("INFO", "Unit rate[F.C] should not be Zero");
      iRes = false;
    }

    if (sBufferObj.B_GrossAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_GrossAmt: "GrossAmt should not be Empty",
      }));
      fAlertToast("INFO", "GrossAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TDiscPerc === "" || sBufferObj.B_TDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_TDiscPerc: "TDiscPerc should not be Empty",
      }));
      fAlertToast("INFO", "TDiscPerc should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_LDiscPerc === "" || sBufferObj.B_LDiscAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line discount.% should not be empty",
      }));
      fAlertToast("INFO", "Line discount.% should not be empty");
      iRes = false;
    }

    if (
      (Number(sBufferObj.B_LDiscPerc) <= 0 &&
        Number(sBufferObj.B_LDiscAmt) !== 0) ||
      (Number(sBufferObj.B_LDiscPerc) !== 0 &&
        Number(sBufferObj.B_LDiscAmt) === 0)
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc: "Line Disc.% or amount should be  Zero",
      }));
      fAlertToast("INFO", "Line Disc.% or amount should be  Zero");
      iRes = false;
    } else if (
      Number(sBufferObj.B_LDiscPerc) > 100 ||
      Number(sBufferObj.B_LDiscPerc) < 0
    ) {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_LDiscPerc:
          "DiscPerc Percentage must be greater than 0 and less than or equal to 100",
      }));
      fAlertToast(
        "INFO",
        "DiscPerc Percentage must be greater than 0 and less than or equal to 100"
      );
      iRes = false;
    }

    if (sBufferObj.B_FocFlag === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocFlag: "FocFlag should not be Empty",
      }));
      fAlertToast("INFO", "FocFlag should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_FocAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_FocAmt: "FocAmt should not be Empty",
      }));
      fAlertToast("INFO", "FocAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxAmt: "ExciseTaxAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_ExciseTaxNetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_ExciseTaxNetAmt: "ExciseTaxNetAmt should not be Empty",
      }));
      fAlertToast("INFO", "ExciseTaxNetAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.SplDisc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDisc: "SplDiscAmt should not be Empty",
      }));
      fAlertToast("INFO", "SplDiscAmt should not be Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept: "TaxDept is Empty" }));
      fAlertToast("INFO", "TaxDept is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc: "TaxPerc is Empty" }));
      fAlertToast("INFO", "TaxPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt: "TaxAmt is Empty" }));
      fAlertToast("INFO", "TaxAmt is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxDept2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxDept2: "TaxDept2 is Empty" }));
      fAlertToast("INFO", "TaxDept2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxPerc2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxPerc2: "TaxPerc2 is Empty" }));
      fAlertToast("INFO", "TaxPerc2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_TaxAmt2 === "") {
      setErrorMsgDetail((obj) => ({ ...obj, B_TaxAmt2: "TaxAmt2 is Empty" }));
      fAlertToast("INFO", "TaxAmt2 is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAddCess === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAddCess: "NetAddCess is Empty",
      }));
      fAlertToast("INFO", "NetAddCess is Empty");
      iRes = false;
    }

    if (sBufferObj.ReduceCost === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        ReduceCost: "Reduce Cost is Empty",
      }));
      fAlertToast("INFO", "Reduce Cost is Empty");
      iRes = false;
    }
    if (sBufferObj.ExpDate === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        ExpDate: "ExpDate Cost is Empty",
      }));
      fAlertToast("INFO", "ExpDate Cost is Empty");
      iRes = false;
    }
    if (sBufferObj.HC === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        HC: "HC Cost is Empty",
      }));
      fAlertToast("INFO", "HC Cost is Empty");
      iRes = false;
    }
    if (sBufferObj.PR === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        PR: "PR Cost is Empty",
      }));
      fAlertToast("INFO", "PR Cost is Empty");
      iRes = false;
    }

    if (sBufferObj.SplDiscPerc === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        SplDiscPerc: "SplDiscPerc is Empty",
      }));
      fAlertToast("INFO", "SplDiscPerc is Empty");
      iRes = false;
    }

    if (sBufferObj.B_NetAmt === "") {
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_NetAmt: "NetAmt is Empty",
      }));
      fAlertToast("INFO", "NetAmt is Empty");
      iRes = false;
    }
  }

  return iRes;
};
const fValidationBatch_Client = (
  sBatchDetailObj,
  setBatchDetailErrorMsg,
  SerialDetalModal
) => {
  let iResp = true;

  if (sBatchDetailObj.BatchDetail_SrNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_SrNo: "Sr.No should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BatchNo === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BatchNo:
        SerialDetalModal.Batch == "Y"
          ? "Batch.No should not be zero"
          : "Serial.No should not be zero",
    }));
    iResp = false;
  }
  if (
    (sBatchDetailObj.BatchDetail_BatchNo === "" ||
      sBatchDetailObj.BatchDetail_BatchNo === 0) &&
    SerialDetalModal?.Serial == "Y"
  ) {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BatchNo:
        sBatchDetailObj.BatchDetail_BatchNo === ""
          ? "Serial.No should not be empty"
          : "Serial.No should not be zero",
    }));
    iResp = false;
  }

  if (sBatchDetailObj.BatchDetail_MFDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_MFDate: "MFDate should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_ExpDate === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_ExpDate: "ExpDate should not be zero",
    }));
    iResp = false;
  }
  if (
    sBatchDetailObj.BatchDetail_Qty === "" ||
    sBatchDetailObj.BatchDetail_Qty <= 0
  ) {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Qty: "Qty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_Unit === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_Unit: "Unit should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_PackQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_PackQty: "PackQty should not be zero",
    }));
    iResp = false;
  }
  if (sBatchDetailObj.BatchDetail_BaseQty === "") {
    setBatchDetailErrorMsg((obj) => ({
      ...obj,
      BatchDetail_BaseQty: "BaseQty should not be zero",
    }));
    iResp = false;
  }
  return iResp;
};
//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", sItemSearch);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch?.Type?.response?.data?.message
        ? vItemSearch?.Type?.response?.data?.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit,
  sDefZeroTaxCode,
  sDefZeroCessCode,
  setRSP_MRP_Obj = () => {}
) => {
  const { HeadObject } = GRNNormalRo();
  const { tax1, tax2 } = vRdxtax();
  if (vItemSearchFull.length > 0) {
    let iTax =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroTaxCode
        : vItemSearchFull[0].TaxDept;

    let iCess =
      HeadObject.TaxType == "INTRN002" || HeadObject.TaxType == "INTRN003"
        ? sDefZeroCessCode
        : vItemSearchFull[0].TaxDept2;

    let vRdxGRNtax1arr = tax1?.find((obj) => {
      return obj.UId === iTax;
    });

    let vRdxGRNtax2arr = tax2?.find((obj) => {
      return obj.UId === iCess;
    });

    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      B_TaxDept: vRdxGRNtax1arr?.UId,
      B_TaxDept2: vRdxGRNtax2arr?.UId,
      B_TaxPerc: vRdxGRNtax1arr?.Perc,
      B_TaxPerc2: vRdxGRNtax2arr?.Perc,
      SuppRefNo1: vItemSearchFull[0].SuppRefNo1,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }

    await Unit_Onchange_001(
      vItemUnitSet?.Unit,
      vItemUnitSet,
      vItemSearchFull[0]?.ItmCd,
      vRdxGRNtax1arr?.Perc,
      vRdxGRNtax2arr?.Perc,
      sBufferObj,
      setBufferObj,
      setRSP_MRP_Obj 
    );

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const Unit_Onchange_001 = async (
  xUnit = "",
  xUnitObj = {},
  xItemCode = sBufferObj.B_Itmcd,
  iTax1Perc = sBufferObj.B_TaxPerc,
  iTax2Perc = sBufferObj.B_TaxPerc2,
  sBufferObj,
  setBufferObj= () => {},
  setRSP_MRP_Obj = () => {}
) => {
  
  let currentPackQty = "";
  //by sir
  const { HeadObject } = GRNNormalRo();
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
    currentPackQty = xUnitObj?.PackQty;
  }

  let resp = await GetUnitRate(
    xItemCode,
    xUnit,
    HeadObject?.A_Party,
    HeadObject?.A_Loc,
    HeadObject?.A_RefDocTyp,
    HeadObject?.A_RefDocNo
  );
  let currentUnitRateObj = {
    B_URateFc: 0,
    B_LDiscPerc: 0,
    AddCess: 0, //addcess
    SplDisc: 0,
    B_ExciseTaxAmt: 0,
  };

  if (resp?.LastPriceDetails.length > 0) {
    currentUnitRateObj = {
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt,
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    };
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: resp?.LastPriceDetails[0].CostLc,
      B_LDiscPerc: resp?.LastPriceDetails[0].DiscPerc,
      AddCess: resp?.LastPriceDetails[0].AddiCess,
      SplDisc: resp?.LastPriceDetails[0].SplDiscAmt,
      B_ExciseTaxAmt: resp?.LastPriceDetails[0].ExciseAmt,
    }));
  } else {
    setBufferObj((obj) => ({
      ...obj,
      B_URateFc: 0,
      B_LDiscPerc: 0,
      AddCess: 0,
      SplDiscAmt: 0,
      B_ExciseTaxAmt: 0,
    }));
  }
  if (resp?.UnitChangeDetails.length > 0) {
    setRSP_MRP_Obj({
      RSP: resp?.UnitChangeDetails[0].RSP,
      MRP: resp?.UnitChangeDetails[0].MRP,
    });
  } else {
    setRSP_MRP_Obj({ RSP: 0, MRP: 0 });
  }

  let {
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
    SplDiscAmt,
  } = fCalculate_Detail(
    sBufferObj.B_Qty,
    currentPackQty,
    HeadObject.A_ExRate,
    currentUnitRateObj.B_URateFc,
    currentUnitRateObj.B_LDiscPerc,
    sBufferObj.B_TDiscPerc,
    sBufferObj.B_FocFlag,
    currentUnitRateObj.B_ExciseTaxAmt,
    iTax1Perc,
    iTax2Perc,
    currentUnitRateObj.AddCess,
    0,
    sBufferObj.SplDiscPerc
  );

  setBufferObj((obj) => ({
    ...obj,
    B_BaseQty,
    B_URateLc,
    B_GrossAmt,
    B_LDiscAmt,
    B_TDiscAmt,
    B_FocAmt,
    B_ExciseTaxNetAmt,
    B_NetAmt,
    B_TaxAmt,
    B_TaxAmt2,
    B_Rounding,
    B_NetAddCess,
    B_LandVal,
    SplDiscAmt,
  }));
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  const { HeadObject } = GRNNormalRo();

  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
    v_Vendor: HeadObject.A_Party || "",
  };
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", vSeatchVendor);
  if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  xRoundingValue = "",
  setDetailGridData,
  setFooterObj,
  xVocTyp
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    var iGrossAmt = 0,
      iTDiscAmt = 0,
      iLDiscAmt = 0,
      iFocAmt = 0,
      iExciseTaxNetAmt = 0,
      iTaxAmt = 0,
      iTaxAmt2 = 0,
      iAddCess = 0,
      iSplDiscAmt1 = 0;

    for (let i = 0; i < iSIDetail?.length; i++) {
      iGrossAmt += iSIDetail[i].B_GrossAmt;
      iTDiscAmt += iSIDetail[i].B_TDiscAmt;
      iLDiscAmt += iSIDetail[i].B_LDiscAmt;
      iFocAmt += iSIDetail[i].B_FocAmt;
      iExciseTaxNetAmt += iSIDetail[i].B_ExciseTaxNetAmt;
      iTaxAmt += iSIDetail[i].B_TaxAmt;
      iTaxAmt2 += iSIDetail[i].B_TaxAmt2;
      iAddCess += iSIDetail[i].B_Ad_NetCessAmt;
      iSplDiscAmt1 += iSIDetail[i].SplDiscAmt1;
    }

    let iLandVal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      // iTaxAmt +
      // iTaxAmt2 +
      // iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    let netAmtFinal =
      iGrossAmt -
      iTDiscAmt -
      iLDiscAmt -
      iFocAmt +
      iExciseTaxNetAmt +
      iTaxAmt +
      iTaxAmt2 +
      iAddCess +
      // iSplDiscAmt1 +
      fcovertToNumber(xRoundingValue);

    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: iGrossAmt.toFixed(2),
      A_TDiscAmt: iTDiscAmt.toFixed(2),
      A_LDiscAmt: iLDiscAmt.toFixed(2),
      A_FocAmt: iFocAmt.toFixed(2),
      A_NetExcise: iExciseTaxNetAmt.toFixed(2),
      A_Tax: iTaxAmt.toFixed(2),
      A_Tax2: iTaxAmt2.toFixed(2),
      A_AddCess: iAddCess.toFixed(2),
      netAmtFinal: netAmtFinal.toFixed(2),
      A_LandVal: iLandVal.toFixed(2),
      A_SplDiscAmt1: iSplDiscAmt1.toFixed(2),
    }));
  } else {
    setDetailGridData([]);
    setFooterObj((obj) => ({
      ...obj,
      A_GrossAmt: 0,
      A_TDiscAmt: 0,
      A_LDiscAmt: 0,
      A_FocAmt: 0,
      A_NetExcise: 0,
      A_Tax: 0,
      A_Tax2: 0,
      A_AddCess: 0,
      A_LandVal: 0,
      A_SplDiscAmt1: 0,
      netAmtFinal: 0,
    }));
  }
};

const fCloseRefDocSearchModal = (
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj
) => {
  setRefDocSearchModal(false);
  fRefDocClearSimpleSearch();
  setRefDocModalArr([]);
  setRefDocModelObj({
    AnyData: "",
    Name: "",
    Code: "",
  });
};
const fReset_Linewise_Rebate = (setBufferObj) => {
  setBufferObj((obj) => ({
    ...obj,
    RebateType: "",
    ReduceCost: "N",
    SplDiscPerc: 0,
    SplDiscAmt: 0,
  }));
};

//GCSimpleSearch for Ref Doc Modal
const fRefDocRowClick = async (
  e,
  dispatch,
  vRdxWmsHead,
  setRefDocSearchModal,
  fRefDocClearSimpleSearch,
  setRefDocModalArr,
  setRefDocModelObj,
  setBufferObj
) => {
  dispatch(
    Set_GRNNormal_HeadObject_Set({
      ...vRdxWmsHead,
      A_RefDocTyp: e?.row?.VocTyp,
      A_RefDocTypName: e?.row?.VocName,
      A_RefDocNo: e?.row?.VocNo,
      A_Party: e?.row?.Vendor,
      A_PartyName: e?.row?.PartyName,
      Type: e?.row?.Source,
      UnloadingBay: e?.row?.LDPay,
      UnloadingBayName: e?.row?.LDPayName,
      A_PostDt: e?.row?.GRNDate,
      A_RefNo: e?.row?.RefNo,
      A_RefDt: e?.row?.RefDate,
      VendorInvAmount: e?.row?.InvAmt,
      A_RefDocVer: e?.row?.SrNo,
    })
  );
  fReset_Linewise_Rebate(setBufferObj);

  GetDefcustomersetting(
    e?.row?.Vendor,
    vRdxWmsHead.A_Loc,
    e?.row?.Source,
    dispatch
  );
  GetDefaultDrCrAccount(
    vRdxWmsHead.A_VocTyp,
    vRdxWmsHead.A_PayMode,
    e?.row?.Vendor,
    dispatch
  );
  // setRefDocModalArr([]);
  setTimeout(() => {
    document.getElementsByName("B_ItmName")[0]?.focus();
  }, 500);
  fCloseRefDocSearchModal(
    setRefDocSearchModal,
    fRefDocClearSimpleSearch,
    setRefDocModalArr,
    setRefDocModelObj
  );
};

//Reverse Modal
const fCloseReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(false);
};

const fOpenReverseTransactionModal = (setReverseTransactionModal) => {
  setReverseTransactionModal(true);
};

const fReverse = (fSave, setRevNarr, setReverseTransactionModal) => {
  fCloseReverseTransactionModal(setReverseTransactionModal);
  confirmAlert({
    title: "Reverse",
    message: "Are you sure to Reverse.",
    buttons: [
      {
        className: "alertBtn",
        label: "Yes",
        onClick: () => fSave(),
      },
      {
        className: "alertBtn",
        label: "No",
        onClick: () => setRevNarr(""),
      },
    ],
  });
};

const fDefaultPayload = (xPaymode, dispatch) => {
  let iPaymode = xPaymode == "BOTH" ? "CREDIT" : xPaymode; //by client
  let DefaultPayload = {
    currentPayMode: iPaymode,
    PaymodeEnable: false,
  };
  if (xPaymode == "BOTH") {
    DefaultPayload.PaymodeEnable = false;
  } else {
    DefaultPayload.PaymodeEnable = true;
  }

  dispatch(
    Set_GRNNormal_HeadObject_A_PayMode({
      A_PayMode: iPaymode,
    })
  );
  return DefaultPayload;
};
const fDiscFlagDependency = (xType, dispatch) => {
  if (xType != "VENDOR_INV") {
    dispatch(
      Set_GRNNormal_HeadObject_DiscFlag({
        A_DiscFlag: "Y",
      })
    );
  }
};

//HEAD LOADING API
// Api

//SALESMAN_GETROW
const GetSalesman = async (dispatch) => {
  const iSalesman = await fExecuteAPI("SALESMAN_GETROW");
  if (iSalesman?.Type?.toUpperCase() === "SUCCESS") {
    return iSalesman.ResultSet.length > 0 ? iSalesman.ResultSet : [];
  } else {
    fAlertToast(
      "FAILED",
      iSalesman.response.data.Status
        ? iSalesman.response.data.Status
        : "Error in Currency"
    );
    return [];
  }
};

//API DEFAULTDRCRACCOUNT_GETROW
const GetDefaultDrCrAccount = async (xVocTyp, xPayMode, xParty, dispatch) => {
  const { HeadObject } = GRNNormalRo();
  let vDefaultDrCrAccountObj = {
    process: sTrnTyp,
    voucher: xVocTyp,
    paymode: xPayMode,
    party: xParty,
    Type: HeadObject.Type,
    Loc: HeadObject.A_Loc,
  };
  const vDefaultDrCrAccount = await fExecuteAPI(
    "DEFAULTDRCRACCOUNT_GETROW",
    vDefaultDrCrAccountObj
  );
  if (vDefaultDrCrAccount?.Type?.toUpperCase() === "SUCCESS") {
    if (vDefaultDrCrAccount?.ResultSet?.length > 0) {
      dispatch(
        Set_GRNNormal_HeadObject_DrCrAccount({
          A_CrAc: !!vDefaultDrCrAccount.ResultSet[0]?.CrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAc
            : "",
          A_CrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.CrAcName
            : "",
          A_DrAc: !!vDefaultDrCrAccount.ResultSet[0]?.DrAc
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAc
            : "",
          A_DrAcName: !!vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            ? vDefaultDrCrAccount.ResultSet[0]?.DrAcName
            : "",
        })
      );
    }
  } else {
    fAlertToast("FAILED", vDefaultDrCrAccount.Message);
  }
};

//API GRN_INV02RCVNGSCSEARCH_GETROW
const GetRefDocInbound = async (
  xAnyData,
  xCode,
  xName,
  setHeaderSearchResultArr
) => {
  let vHeaderSearchObj = {
    v_RefDocNo: xAnyData,
    v_InvoiceNo: xCode,
    v_GrnDocNo: xName,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_INV02RCVNGSCSEARCH_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    vHeaderSearchObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

//API Unit GETITEMUNITSINBOUND_GETROW
const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  const UnitInfo = await fExecuteAPI("GETITEMUNITSINBOUND_GETROW", itemUnitobj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo?.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo?.Type?.response?.data?.message
        ? UnitInfo?.Type?.response?.data?.message
        : "Error in UnitArr"
    );
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", vItemLineObj);
  if (ItemLineInfo?.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo?.Type?.response?.data?.message
        ? ItemLineInfo?.Type?.response?.data?.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  const UnitRateInfo = await fExecuteAPI(
    // "INBOUNDUNITRATE_GETROW",
    "Inbound_Unit_Rate_GRN",
    vUnitRateObj
  );
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo?.ResultSet) {
      return UnitRateInfo?.ResultSet;
    } else {
      return {
        price: [],
        mrp: [],
      };
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo?.Type?.response?.data?.message
        ? UnitRateInfo?.Type?.response?.data?.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};
export const GetUnitRate = async (
  xItmCd,
  xUnitId,
  xParty,
  xLoc,
  xVocTyp,
  xVocNo
) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    Unit: xUnitId,
    Party: xParty,
    Loc: xLoc,
    VocTyp: xVocTyp,
    VocNo: xVocNo,
  };
  const resp = await fUnitPriceOnChangeGRN(vUnitRateObj);
  if (resp?.status === 200) {
    if (!!resp.data.ResultSet) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    vItemFullSearchDataObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull?.ResultSet?.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  const { HeadObject } = GRNNormalRo();
  let iSIDetailObj = {
    v_VocTyp: HeadObject.A_VocTyp || "",
    v_VocNo: HeadObject.A_VocNo || "",
    v_SrNo: xB_Srno,
    v_TrnTyp: sTrnTyp,
  };
  const resp = await GRNNormal_INV03_LoadDetail_GETROW(iSIDetailObj);
  if (resp?.status === 200) {
    if (resp.data.ResultSet?.length > 0) {
      return resp?.data?.ResultSet;
    } else {
      return [];
    }
  }
};

//API GETITEMATTRIBUTES_GETROW
const fValidateItemsAttributes = async (sBufferObj, setErrorMsgDetail) => {
  const { HeadObject } = GRNNormalRo();
  let vItemAttributesObj = {
    itmCd: sBufferObj.B_Itmcd,
    loc: HeadObject.A_Loc,
    taxType: HeadObject.TaxType,
    unit: sBufferObj.B_Unit,
  };
  const vItemAttributes = await fExecuteAPI(
    "GETITEMATTRIBUTES_GETROW",
    vItemAttributesObj
  );

  if (
    vItemAttributes?.Type?.toUpperCase() === "SUCCESS" &&
    vItemAttributes?.ResultSet?.length > 0
  ) {
    let vGetItemAttributes = vItemAttributes.ResultSet[0];
    let iRes = true;

    if (vGetItemAttributes.Linking != "") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_Itmcd: vGetItemAttributes.Linking,
      }));
      iRes = false;
    }

    if (vGetItemAttributes.ItmActive == "N") {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_ItmName: "Item is in-actived",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxDept1 != sBufferObj.B_TaxDept) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept: "Tax code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc1 != sBufferObj.B_TaxPerc) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc: "Tax % is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxDept2 != sBufferObj.B_TaxDept2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxDept2: "Cess code is not matching",
      }));
      iRes = false;
    }

    if (vGetItemAttributes.TaxPerc2 != sBufferObj.B_TaxPerc2) {
      setErrorMsgDetail((...obj) => ({
        ...obj,
        B_TaxPerc2: "Cess % is not matching",
      }));
      iRes = false;
    }

    return { iRes, vGetItemAttributes };
  } else {
    fAlertToast("FAILED", "GETITEMATTRIBUTES_GETROW");
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (
  xA_VocTyp,
  A_VocNo,
  dispatch,
  fNewDetail,
  fBuyreGetRow
) => {
  const { HeadObject } = GRNNormalRo();
  let vSIHeadObj = {
    v_A_VocTyp: xA_VocTyp || "",
    v_A_VocNo: A_VocNo || "",
  };
  const resp = await GRNNormal_fINV03_fDisplay_GETROW(vSIHeadObj);

  if (resp?.status === 200) {
    dispatch(
      Set_GRNNormal_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: resp?.data?.ResultSet[0].A_VocTyp,
        A_VocTypName: resp?.data?.ResultSet[0].VocName,
        A_VocNo: resp?.data?.ResultSet[0].A_VocNo,
        A_PostDt: resp?.data?.ResultSet[0].A_PostDt,
        A_RefDt: resp?.data?.ResultSet[0].A_RefDt,
        A_RefNo: resp?.data?.ResultSet[0].A_RefNo,
        A_Party: resp?.data?.ResultSet[0].A_Party,
        A_PartyName: resp?.data?.ResultSet[0].PartyName,
        A_Curr: resp?.data?.ResultSet[0].A_Curr,
        A_Currname: resp?.data?.ResultSet[0].CurrName,
        A_ExRate: resp?.data?.ResultSet[0].A_ExRate,
        A_PayMode: resp?.data?.ResultSet[0].A_PayMode,
        Type: resp?.data?.ResultSet[0].A_Type,
        A_Loc: resp?.data?.ResultSet[0].A_Loc,
        A_Buyer: resp?.data?.ResultSet[0].A_Buyer, ////SalesMan
        A_Narr: resp?.data?.ResultSet[0].A_Narr,
        A_CrAc: resp?.data?.ResultSet[0].A_CrAc,
        A_CrAcName: resp?.data?.ResultSet[0].CrAcName,
        A_DrAc: resp?.data?.ResultSet[0].A_DrAc,
        A_DrAcName: resp?.data?.ResultSet[0].DrAcName,
        A_DiscPerc: resp?.data?.ResultSet[0].A_DiscPerc
          ? resp?.data?.ResultSet[0].A_DiscPerc
          : 0,
        A_Rounding: resp?.data?.ResultSet[0].A_Rounding
          ? resp?.data?.ResultSet[0].A_Rounding
          : 0,
        A_DocStat: resp?.data?.ResultSet[0].A_DocStat,
        TaxType: resp?.data?.ResultSet[0].A_CUSTFIELD3,
        A_TaxGross: resp?.data?.ResultSet[0].A_TaxGross,
        A_Taxable: resp?.data?.ResultSet[0].A_Taxable,
        A_Br: resp?.data?.ResultSet[0].A_Br, //LocationBrCode
        A_GrossAmt: resp?.data?.ResultSet[0].A_GrossAmt, //decimal
        A_DiscAmt: resp?.data?.ResultSet[0].A_DiscAmt, //decimal
        A_DiscFlag: resp?.data?.ResultSet[0].A_DiscFlag,
        A_TaxAmt: resp?.data?.ResultSet[0].A_TaxAmt, //decimal
        A_NetAmt: resp?.data?.ResultSet[0].A_NetAmt, //decimal
        A_LC: resp?.data?.ResultSet[0].A_LC, //decimal
        A_Charges1: resp?.data?.ResultSet[0].A_Charges1, //decimal
        PurchaseReturnType: resp?.data?.ResultSet[0].A_PR_DocTyp, //decimal

        VendorInvAmount: resp?.data?.ResultSet[0].A_RefNo4, //INvoice Amount

        offer:
          resp?.data?.ResultSet[0].A_CUSTFIELD5 == "" ||
          resp?.data?.ResultSet[0].A_CUSTFIELD5 == null
            ? "N"
            : resp?.data?.ResultSet[0].A_CUSTFIELD5, // Offer Y/N
        RCM:
          resp?.data?.ResultSet[0].A_CUSTFIELD4 == "" ||
          resp?.data?.ResultSet[0].A_CUSTFIELD4 == null
            ? "N"
            : resp?.data?.ResultSet[0].A_CUSTFIELD4,
        Weighing:
          resp?.data?.ResultSet[0].A_ScaleItm == "" ||
          resp?.data?.ResultSet[0].A_ScaleItm == null
            ? "N"
            : resp?.data?.ResultSet[0].A_ScaleItm,
        Tax:
          resp?.data?.ResultSet[0].A_Taxable == "" ||
          resp?.data?.ResultSet[0].A_Taxable == null
            ? "N"
            : resp?.data?.ResultSet[0].A_Taxable,
        TaxGross:
          resp?.data?.ResultSet[0].A_TaxGross == "" ||
          resp?.data?.ResultSet[0].A_TaxGross == null
            ? "N"
            : resp?.data?.ResultSet[0].A_TaxGross,
        Rebate:
          resp?.data?.ResultSet[0].Repeat == "" ||
          resp?.data?.ResultSet[0].Repeat == null
            ? "N"
            : resp?.data?.ResultSet[0].Repeat,
        Batch: resp?.data?.ResultSet[0].A_CUSTFIELD8,
        A_RefDocTyp: resp?.data?.ResultSet[0].A_RefDocType || "",
        A_RefDocTypName: resp?.data?.ResultSet[0].A_RefDocTypeName || "",
        A_RefDocNo: resp?.data?.ResultSet[0].A_RefDocNo || "",
        POBarcode: resp?.data?.ResultSet[0].A_RefDocBarcode || "",
      })
    );
    // ItemsAliasListSearch(vSIHead.ResultSet[0].A_Loc, sBufferObj.B_Itmcd);

    fBuyreGetRow(
      resp?.data?.ResultSet[0].A_VocTyp,
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_Loc
    );

    fNewDetail(
      resp?.data?.ResultSet[0].A_VocNo,
      resp?.data?.ResultSet[0].A_Rounding,
      resp?.data?.ResultSet[0].A_VocTyp,
      resp?.data?.ResultSet[0]?.A_CUSTFIELD3
    );
  }
};

export const MultiCardFlag = () => {
  const { DBKernObj } = KernCAConfig();
  const iShowField = DBKernObj?.MULT_CARD_ID?.Val === "Y";

  if (iShowField) {
    return true;
  } else {
    return false;
  }
};
//API SAVESIDETAIL_GETROW
const fSaveDetail = async (
  xB_VocNo,
  sBufferObj,
  fNewDetail,
  fOpenBatchModal,
  setBatchUnit,
  setBatchObj,
  setBatchDetailObj
) => {
  const { HeadObject } = GRNNormalRo();
  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_URateFc: sBufferObj.B_URateFc,
    B_URateLc: sBufferObj.B_URateLc,
    B_GrossAmt: sBufferObj.B_GrossAmt,
    B_LDiscPerc: sBufferObj.B_LDiscPerc,
    B_LDiscAmt: sBufferObj.B_LDiscAmt,
    B_FocFlag: sBufferObj.B_FocFlag,
    B_AprmtFlag: sBufferObj.B_AprmtFlag,
    B_RefDocTyp: HeadObject.A_RefDocTyp,
    B_RefDocNo: HeadObject.A_RefDocNo,
    B_RefNo2: "",
    B_RefNo3: "",
    B_RefNo5: 0,
    B_ExciseTaxAmt: sBufferObj.B_ExciseTaxAmt,
    B_ExciseTaxNetAmt: sBufferObj.B_ExciseTaxNetAmt,
    B_TaxPerc: sBufferObj.B_TaxPerc,
    B_TaxAmt: sBufferObj.B_TaxAmt,
    SplDiscAmt1: sBufferObj.SplDisc,
    SplDiscAmt2: sBufferObj.SplDiscPerc,
    SplDiscAmt3: sBufferObj.SplDiscAmt,
    Field1: 0,
    Field2: 0,
    Field6: sBufferObj.RebateType,
    Field7: sBufferObj.ReduceCost,
    Field8: sBufferObj?.Narration,
    Field9: "",
    Field10: "",
    B_TaxDept: sBufferObj.B_TaxDept,
    B_TaxDept2: sBufferObj.B_TaxDept2,
    B_TaxPerc2: sBufferObj.B_TaxPerc2,
    B_TaxAmt2: sBufferObj.B_TaxAmt2,
    B_IncGroup: sBufferObj.B_IncGroup,
    B_SuprvPerc: sBufferObj.B_SuprvPerc,
    B_OthersPerc: sBufferObj.B_OthersPerc,
    B_SLANSuprv: sBufferObj.B_SLANSuprv,
    B_SlabAmtSuprv: sBufferObj.B_SlabAmtSuprv,
    B_SLANOther: sBufferObj.B_SLANOther,
    B_SlabAmtOther: sBufferObj.B_SlabAmtOther,
    B_Ad_CessAmt: 0, //by sir
    B_Ad_PCQty: 0, //by sir
    B_Ad_PCRate: sBufferObj.AddCess,
    B_Ad_NetCessAmt: sBufferObj.B_NetAddCess,
    HC: "N",
    PR: "N",
    ExpDate: "",
  };

  const vSaveSIDetail = await fExecuteAPI(
    "GRN_SAVE_DETAIL_GETROW_001",
    vSaveSIDetailObj
  );
  if (vSaveSIDetail.Type?.toUpperCase() === "SUCCESS") {
    fOpenBatchModal(
      vSaveSIDetail.ResultSet[0].B_Srno,
      sBufferObj.B_BaseQty,
      sBufferObj.B_PackQty
    );
    setBatchObj((obj) => ({
      ...obj,
      SrNo: vSaveSIDetail.ResultSet[0].B_Srno,
      ItemCode: sBufferObj.B_Itmcd,
      ItemName: sBufferObj.B_ItmName,
      Qty: sBufferObj.B_Qty,
      Unit: sBufferObj.B_UnitName,
      BaseQty: sBufferObj.B_BaseQty,
    }));
    let vBatchUnit = await GetUnitArr(sBufferObj.B_Itmcd, setBatchUnit);
    setBatchDetailObj((obj) => ({
      ...obj,
      BatchDetail_Unit: sBufferObj.B_Unit,
      BatchDetail_Qty: 0,
      BatchDetail_PackQty: sBufferObj.B_PackQty,
      BatchDetail_BaseQty: 0,
    }));
    fNewDetail(
      xB_VocNo,
      HeadObject.A_Rounding,
      HeadObject?.A_VocTyp,
      HeadObject?.TaxType
    );
    if (vSaveSIDetail.ResultSet[0].isVariComp == "Y") {
      fAlertToast(
        "SUCCESS",
        "You have completed the variance and saved Successfully"
      );
    } else {
      fAlertToast("SUCCESS", "Successfully Saved");
    }
  }
};

export const SalesReturnLineItem_Validation = async (dispatch, sBufferObj) => {
  const { HeadObject } = GRNNormalRo();

  let iRespObj = {
    v_VocTyp: HeadObject.A_VocTyp,
    v_VocNo: HeadObject.A_VocNo,
    v_SrNo: sBufferObj.B_Srno,
    v_RefVocTyp: HeadObject.A_RefDocTyp,
    v_RefVocNo: HeadObject.A_RefDocNo,
    v_RefSrNo: HeadObject.A_RefDocVer,
    v_ItmCd: sBufferObj.B_Itmcd,
    v_Qty: sBufferObj.B_Qty,
    v_Unit: sBufferObj.B_Unit,
  };

  const iResp = await fExecuteAPI("SalesReturnLineItemValidation", iRespObj);
  console.log("asdasfda", iResp);
  if (iResp.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else {
    fAlertToast(
      "FAILED",
      iResp?.response?.data?.message || "Error in SalesReturnLineItem"
    );
    return false;
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  const vTransTaxType = await fExecuteAPI(
    "TransTaxType_GETROW",
    vTransTaxTypeObj
  );
  if (vTransTaxType.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

//API SAVE_DETAIL_BATCH_GETROW_001
const GetSaveDetailBatch = async (sBatchObj, sBatchDetailObj, dispatch) => {
  const { HeadObject } = GRNNormalRo();

  let vSaveDetailBatchObj = {
    v_C_VocTyp: HeadObject.A_VocTyp,
    v_C_VocNo: HeadObject.A_VocNo,
    v_C_SrNo: sBatchObj.SrNo,
    v_C_ItmCd: sBatchObj.ItemCode,
    v_C_Qty: sBatchDetailObj.BatchDetail_Qty,
    v_C_Unit: sBatchDetailObj.BatchDetail_Unit,
    v_C_BaseQty: sBatchDetailObj.BatchDetail_BaseQty,
    v_C_Narr: "",
    v_C_BatchNo: sBatchDetailObj.BatchDetail_BatchNo,
    v_C_BatchDt: moment(sBatchDetailObj.BatchDetail_MFDate).format(
      "MM/DD/YYYY"
    ),
    v_C_ExpDt: moment(sBatchDetailObj.BatchDetail_ExpDate).format("MM/DD/YYYY"),
    v_C_PTyp1: "",
    v_C_PTyp2: "",
    v_C_PTyp3: 0,
    v_C_PTyp4: 0,
    v_C_PTyp5: 0,
    v_C_PTyp6: 0,
    v_C_RowID: sBatchDetailObj.BatchDetail_SrNo,
  };
  const resp = await GRNNormal_updateInv03CRow_GETROW(vSaveDetailBatchObj);
  if (resp?.status === 200) {
    fAlertToast("SUCCESS", "Successfully Saved");
    return true;
  } else {
    fAlertToast("FAILED", "Batch not saved");
    return false;
  }
};

//API DELETE_DETAIL_BATCH_GETROW_001
const GetDeleteDetailBatch = async (xSrNo, xRowId, dispatch) => {
  const { HeadObject } = GRNNormalRo();
  let vDeleteDetailBatchObj = {
    v_C_VocTyp: HeadObject.A_VocTyp,
    v_C_VocNo: HeadObject.A_VocNo,
    v_C_SrNo: xSrNo,
    v_C_RowID: xRowId,
  };
  const resp = await GRNNormal_deleteInv03CRow_GETROW(vDeleteDetailBatchObj);

  if (resp?.status === 200) {
    console.log(resp);
    fAlertToast("SUCCESS", "Successfully Deleted");
    return true;
  } else {
    fAlertToast("FAILED", "Batch not Deleted");
    return false;
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const GetBatchDetail = async (xSrNo) => {
  const { HeadObject } = GRNNormalRo();
  let vBatchDetailObj = {
    v_C_VocTyp: HeadObject?.A_VocTyp,
    v_C_VocNo: HeadObject?.A_VocNo,
    v_C_SrNo: xSrNo,
  };
  const resp = await GRNNormal_Inv03CgetRow_GETROW(vBatchDetailObj);
  if (resp?.status === 200) {
    console.log(resp);
    let respData =
      resp?.data?.ResultSet?.length == 0
        ? []
        : resp?.data?.ResultSet.map((obj, i) => ({
            ...obj,
            id: i + 1,
          }));
    return respData;
  } else {
    return [];
  }
};

//API WMINV03D_GetRow
const Get_Loaded_Cost_WMINV03D_GetRow = async (dispatch) => {
  const { HeadObject } = GRNNormalRo();
  let vLoadedCostObj = {
    VocTyp: HeadObject?.A_VocTyp,
    VocNo: HeadObject?.A_VocNo,
  };
  const vLoadedCost = await GRNNormal_INV03D_GetRow_GETROW(vLoadedCostObj);
  if (vLoadedCost?.status === 200) {
    return vLoadedCost?.data?.ResultSet.length > 0
      ? vLoadedCost?.data?.ResultSet
      : [];
  }
};

//API GET_BATCH_DETAILS_GETROW_001
const Get_LoadedCost = async (xData, xType, xAcTyp, xExact, dispatch) => {
  const { HeadObject } = GRNNormalRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

export var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//defcustomersetting_GETROW
const GetDefcustomersetting = async (xAcCd, xLoc, xType, dispatch) => {
  const { HeadObject } = GRNNormalRo();
  const { DBKernObj } = KernCAConfig();

  if (DBKernObj?.SONAS_INVOICE?.Val === "Y" && xType == "SALES_RETURN") {
    let vdefcustomersettingObj = {
      accd: xAcCd,
      loc: xLoc,
    };
    const vdefcustomersetting = await fExecuteAPI(
      "defcustomersetting_GETROW",
      vdefcustomersettingObj
    );
    if (vdefcustomersetting?.Type?.toUpperCase() == "SUCCESS") {
      if (
        vdefcustomersetting.ResultSet.length > 0 &&
        !!vdefcustomersetting.ResultSet[0].SalesMan
      ) {
        dispatch(
          Wms_HeadObject_SalesGroup_A_Buyer_Set({
            A_Buyer: !!vdefcustomersetting.ResultSet[0].SalesMan
              ? vdefcustomersetting.ResultSet[0].SalesMan
              : HeadObject.A_Buyer,
          })
        );
      }
    } else {
      fAlertToast(
        "FAILED",
        !!vdefcustomersetting.Message
          ? vdefcustomersetting.Message
          : "Error in default setting customer"
      );
    }
  }
};

//GC customer
const Get_ToggleDropDown_Load = async (
  xData,
  xType,
  xAcTyp,
  xExact,
  dispatch
) => {
  const { HeadObject } = GRNNormalRo();
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: HeadObject.A_Loc,
    AcTyp: xAcTyp,
    Exact: xExact,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "AccountTransSearch_GETROW",
    FinalObj
  );
  if (vLandedCostDropdownSearch.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch.ResultSet.length > 0) {
      let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};
//API GET_BATCH_DETAILS_GETROW_001
const Get_GCSearchBtn = async (xData, xType, xExact = "N") => {
  const vRdxUserInfoObj = vRdxUserInfo();
  let vLoaded_Cost_FreightObj = {
    v_Data: xData,
    v_Type: xType,
    v_TrnTyp: sTrnTyp,
    v_UserId: vRdxUserInfoObj.UserID,
    Exact: xExact,
  };
  const vLandedCostDropdownSearch = await fExecuteAPI(
    "Common_transpartylist_GETROW",
    vLoaded_Cost_FreightObj
  );
  if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
    let GridID = [];
    if (vLandedCostDropdownSearch?.ResultSet?.length > 0) {
      let GridID = vLandedCostDropdownSearch?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in loading LandedCost Api");
    return [];
  }
};

export const GetAttributes = async (
  setObjectRights,
  setUser_Doc_Arr,
  setDocLoading,
  setCurrency,
  setType,
  setLoc,
  setPurchaseReturnType
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await GRNNormal_Attributes_GETROW(vObj);
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setPurchaseReturnType(iAttributes?.data?.ResultSet?.PurchaseReturnType);
    setCurrency(iAttributes?.data?.ResultSet?.Currency);
    setType(iAttributes?.data?.ResultSet?.Type);
    setLoc(iAttributes?.data?.ResultSet?.Loc);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};

export const GetMSPUpdate = async (xVocTyp, xVocNo, setGridDataRows) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    v_VocTyp: xVocTyp,
    v_VocNo: xVocNo,
    v_TrnTyp: sTrnTyp,
    v_UserCd: vRdxUserInfoObj.UserID,
  };

  const iRespDetail = await WMSIInbound_WMINV03RSPMSPDetail_API(vObj);
  if (iRespDetail?.status === 200 && iRespDetail?.data?.ResultSet.length > 0) {
    let vItemSearchArr = iRespDetail?.data?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridDataRows(vItemSearchArr);

    return iRespDetail?.data?.ResultSet;
  } else {
    setGridDataRows([]);
    return [];
  }
};

export const fCal_MSPGPPerc = (xMSP, xCostPR) => {
  let MSPGPPerc =
    Number(xMSP) === 0
      ? 0
      : Number(
          (((Number(xMSP) - Number(xCostPR)) / Number(xMSP)) * 100).toFixed(2)
        );
  return MSPGPPerc;
};

export const fCal_TAXRSP = (xSellPr1, xTaxPer) => {
  let iTAXRSP = Number(xSellPr1) + (Number(xSellPr1) * Number(xTaxPer)) / 100;
  return iTAXRSP;
};

export const fCal_GPPerc = (xSellPr1, xCostPR) => {
  let iGPPerc =
    Number(xSellPr1) === 0
      ? 0
      : Number(
          (
            ((Number(xSellPr1) - Number(xCostPR)) / Number(xSellPr1)) *
            100
          ).toFixed(2)
        );
  return iGPPerc;
};
export const fCal_SellPr1 = (xTaxPerc, xTAXRSP) => {
  let SellPr1 =
    Number(xTaxPerc) + 100 === 0
      ? 0
      : (Number(xTAXRSP) * 100) / (Number(xTaxPerc) + 100);
  return SellPr1;
};

export {
  // rows,
  // columns,
  Get_GCSearchBtn,
  fRightClick,
  fLeftClick,
  sPaymode,
  sTax,
  sFocFlagArr,
  TypeArr,
  fKey,
  // Api
  GetSalesman,
  GetDefaultDrCrAccount,
  GetRefDocInbound,
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetUnitRateArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  Unit_Onchange_001,
  GetSearchItem,
  GetTransTaxType,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fValidateItemsAttributes,
  fSaveDetail,
  fDisplay,

  //refdocmodal
  fRefDocRowClick,
  fCloseRefDocSearchModal,

  //reverse
  fCloseReverseTransactionModal,
  fOpenReverseTransactionModal,
  fReverse,

  //Head functions
  fDefaultPayload,
  fDiscFlagDependency,
  //Batch
  fValidationBatch_Client,
  GetSaveDetailBatch,
  GetDeleteDetailBatch,
  GetBatchDetail,

  //src doc
  fReset_Linewise_Rebate,
  //GCLoadedCost
  Get_LoadedCost,
  Get_Loaded_Cost_WMINV03D_GetRow,
  GetDefcustomersetting,
  //GCCustomer
  Get_ToggleDropDown_Load,
};
